// extracted by mini-css-extract-plugin
export var bounce = "_or-1";
export var generatingText = "_or-6";
export var lightning = "_or-4";
export var popup = "_or-5";
export var progressBar = "_or-7";
export var progressFill = "_or-8";
export var progressShimmer = "_or-9";
export var progressText = "_or-a";
export var shimmer = "_or-3";
export var uploadIcon = "_or-0";
export var uploadingText = "_or-2";